import { Visibility } from '@mui/icons-material';
import { Alert } from '@mui/material';
import { lang } from 'src/utils';

import { ViewOnlyAlertContainer } from './ViewOnlyAlert.styled';

export const ViewOnlyAlert = () => {
  return (
    <ViewOnlyAlertContainer>
      <Alert severity="info" icon={<Visibility fontSize="inherit" />}>
        {lang.viewOnly}
      </Alert>
    </ViewOnlyAlertContainer>
  );
};
